/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter, Link } from 'react-router-dom'
import { Row, Col, Table, Input, Empty, Pagination, Spin } from 'antd'
// import './index.scss'
import _ from 'lodash'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'
import timeAgo from 'node-time-ago'
import UserAvatar from '../../components/Custom/UserAvatar'
import moment from 'moment'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			page: 1,
			pageSize: 10,
			searchText: '',
			sortOrder: null,
			sortName: null,
		}
		this.handleOnChange = this.handleOnChange.bind(this)
		this.handlePaginationSizeChanger = this.handlePaginationSizeChanger.bind(this)
	}

	handleOnChange(current, pageSize) {
		this.setState({
			page: current,
			pageSize: pageSize
		})
	}

	handlePaginationSizeChanger(current, pageSize) {
		this.setState({
			page: current,
			pageSize: pageSize
		})
	}

	render() {
		const { 
			page, pageSize, searchText, sortOrder, sortName
		} = this.state
		const { AuthStore, markAsSeen, history } = this.props
		const { user_uid } = AuthStore
		const filters = { 
			page, pageSize, searchText, sortOrder, sortName
		}
		return (
			<React.Fragment>
				<div className="row">
					<div className="col-12">
						<div className="page-title-box">
							<div className="page-title-right">
								<ol className="breadcrumb m-0">
									<li className="breadcrumb-item"><Link to='/'>Dashboard</Link></li>
									<li className="breadcrumb-item active">Notifications</li>
								</ol>
							</div>
							<h4 className="page-title">Notifications</h4>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-12">
						<div className='card'>
							<div className='card-body'>
								<Query 
									query={NOTIFICATIONS} 
									variables={{ searchFilter: filters, user_uid }}
									fetchPolicy='network-only'
								>
									{({ loading, error, data }) => {
										if (error) return <span>{error.message}</span>
										console.log('data', data)
										let notifications = _.has(data,'userNotifications') ? data.userNotifications.data : []
										notifications = notifications.map((notification, key) => Object.assign({}, notification, { key }))
										let _pagination = _.has(data, 'userNotifications') ? data.userNotifications.pagination : {}
										_pagination = Object.assign({}, _pagination, {
											pageSizeOptions: ['10', '25', '50'],
											showSizeChanger: true,
											total: _.has(_pagination, 'rowCount') ? _pagination.rowCount : 0,
											showTotal: (total) => `Total ${total} items`
										})
									

										return (
											<Row type='flex' justify='center'>
												<Col md={12} sm={24}>
													<Row>
														{
															(notifications.length > 0) && notifications.map((notification, key) => {
																const notSeen = (notification.is_seen == 0) ? 'notSeen' : null
																return (
																	<React.Fragment key={key}>
																		<Row className={`notifs-list-item ${notSeen}`} gutter={16} onClick={()=>{
																			if (notSeen) {
																				markAsSeen(notification.uid)
																			}
																			if (notification.link_url) {
																				history.push(notification.link_url)
																			}
																		}}>
																			<Col style={{ textAlign: 'center', marginTop: '5px' }} md={4} sm={12}>
																				<img width='50' height='auto' className='img-fluid' src={`${process.env.REACT_APP_BACKEND_API}${notification.icon_url}`} alt="" />
																			</Col>
																			<Col md={20} sm={12}>
																				<span>{notification.notification_message}</span>
																				<br/>
																				<small>{timeAgo(moment(notification.created_at).format('YYYY-MM-DD HH:mm:ss'))}</small>
																			</Col>
																		</Row>
																		<hr/>
																	</React.Fragment>
																)
															})
														}
														{
															(notifications.length == 0) && <Empty/>
														}
														{
															loading && <Spin/>
														}
													</Row>
													{
														(notifications.length > 0) &&
														<Row style={{ marginTop: '30px', float: 'right' }}>
															<Pagination 
																current={_pagination.page}
																pageSize={_pagination.pageSize}
																onChange={this.handleOnChange}
																onShowSizeChange={this.handlePaginationSizeChanger}
																pageSizeOptions={['5', '10', '20', '50']}
																showSizeChanger
																size='small'
																total={_.has(_pagination, 'rowCount') ? _pagination.rowCount : 0}
																showTotal={(total) => `Total ${total} items`}
															/>
														</Row>
													}
												</Col>
											</Row>
										)
									}}
								</Query>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}

const NOTIFICATIONS = gql`
    query userNotifications($user_uid: String, $searchFilter: SearchParams) {
		userNotifications(user_uid: $user_uid, searchFilter: $searchFilter)
    }
`

const MARK_AS_SEEN = gql`
    mutation markAsSeenNotification($notif_uid: String) {
		markAsSeenNotification(notif_uid: $notif_uid)
    }
`

const composed = compose(
	withRouter,
	inject('AuthStore'),
	graphql(MARK_AS_SEEN, {
		props({ mutate }) {
			return {
				markAsSeen(notif_uid) {
					return mutate({
						variables: { notif_uid },
					  	refetchQueries: ['userNotifications']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
